import React from 'react';
import './style.scss';
import { FeatureGroup, Polygon } from 'react-leaflet';
import PopupComponent from '../PopupComponent/PopupComponent';


export default function PolygonComponent(props) {
    const { positions, styles, popupContent, popupType } = props;
    return (
        <FeatureGroup >
            {popupContent !== undefined ? <PopupComponent popupType={popupType} title={popupContent} /> : <div></div>}
            <div className="polygon_component">
                <Polygon className="polygon" weight={styles.weight} color={styles.color} fillColor={styles.fillColor} fillOpacity={styles.fillOpacity} positions={positions} />
            </div>
        </FeatureGroup>
    );
}